import axios from 'axios';

const esriGeocodeClient = axios.create({
    baseURL: 'https://geocode.arcgis.com',
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

const esriServiceClient = axios.create({
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

const searchBounds =  [[43.530209, -66.431514], [47.477872, -59.647943]];


export default {
    esriGeocoderSuggestions(search: string, lat: number, lon: number) {
        return esriGeocodeClient.get(`https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?text=${encodeURI(search)}&location=${lon}%2C${lat}&distance=50000&searchExtent=%7B%22xmin%22%3A-69.8232995%2C%22ymin%22%3A41.5563775%2C%22xmax%22%3A-56.2561575%2C%22ymax%22%3A49.4517035%2C%22spatialReference%22%3A%7B%22wkid%22%3A4326%7D%7D&maxSuggestions=5&f=json&token=AAPK1169c3fb47a04a479e3c04f79defa37abYXyZsmpnFHdJQeICgSfKflpSVFxQMe7D5MLKb-pseJXK4rGBChxFMizLYit7U8b`);
    },
    esriGeocoderCandidates(text: string, magicKey: string) {
        return esriGeocodeClient.get(`https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?outSr=4326&forStorage=false&outFields=*&maxLocations=5&singleLine=${encodeURI(text)}&magicKey=${encodeURI(magicKey)}&searchExtent=%7B%22xmin%22%3A-66.431514%2C%22ymin%22%3A43.530209%2C%22xmax%22%3A-59.647943%2C%22ymax%22%3A47.477872%2C%22spatialReference%22%3A%7B%22wkid%22%3A4326%7D%7D&f=json&token=AAPK1169c3fb47a04a479e3c04f79defa37abYXyZsmpnFHdJQeICgSfKflpSVFxQMe7D5MLKb-pseJXK4rGBChxFMizLYit7U8b`);
    },
    mlsFuzzyQuery(text: string) {
        // TODO this can be improved
        // TODO don't need the upper for numeric
        // TODO use config
        return esriServiceClient.get(`https://remaxnova-api-dev.azurewebsites.net/api/featureservice/search/query?searchText=${text}`);
    },
    pidExactQuery(pid: string) {
        // this will return geometry
        return esriServiceClient.get(`https://remaxnova-api.azurewebsites.net/api/featureservice/parcels_ro/query?returnGeometry=true&where=PID%3D%27${pid}%27&outSr=4326&outFields=*&f=geojson`);
    },
    pidCentroidQuery(pid: string) {
        return esriServiceClient.get(`https://remaxnova-api.azurewebsites.net/api/parcels/${pid}/centroid`);
    },
    listingGeometry(objectid: number) {
        // gets exact listing with geometry
        return esriServiceClient.get(`https://remaxnova-api-dev.azurewebsites.net/api/featureservice/search/query?objectId=${objectid}&f=geojson`);
    },
    listingGeometryBySystemId(systemId: string) {
        // gets exact listing with geometry
        return esriServiceClient.get(`https://remaxnova-api-dev.azurewebsites.net/api/featureservice/search/query?searchText=${systemId}&f=geojson`);
    },
    listingByAddress(address: string) {
        // gets listing by address, this is a fuzzy search and will return multiple results
        return esriServiceClient.get(`https://remaxnova-api-dev.azurewebsites.net/api/listings/byaddress?searchText=${encodeURI(address)}`);
    },
};
